/**
 * Only HTTPS links are supported now
 * https://w.amazon.com/bin/view/MSA/HowTo/UsingCorrectImageDomains/#Using_Correct_Image_Domains
 */

const endpoint = "https://m.media-amazon.com"

/**
 * Detect MSA image server based on desired protocol and fabric.
 */
export function getProductImageServer() {
  return endpoint
}
